<template>
  <div>
    <div class="h-bar">
      <div class="name">Diyabetik Ketoasidoz Protokolü</div>
    </div>
    <div id="content" class="yatis-content">
      <div class="protokol">
        <h3>Hasta Bilgileri</h3>
        <div class="labeledit">
          <label for="p-adi">Adı Soyadı : </label>
          <input type="text" id="p-adi" v-model="ketoasidoz.adi" />
        </div>
        <div class="labeledit">
          <label for="p-kilo">Kilo : </label>
          <input
            type="number"
            id="p-kilo"
            v-model="ketoasidoz.kilo"
            step="any"
          />
        </div>
        <div class="labeledit">
          <label for="p-start">Protokol Başlama Zamanı</label>
          <input
            type="datetime-local"
            id="p-start"
            v-model="ketoasidoz.dkastart"
          />
        </div>
        <h3>Başvuru Değerleri</h3>
        <div class="labeledit">
          <label for="p-seker">Geliş KŞ : </label>
          <input
            type="number"
            name=""
            id="p-seker"
            min="0"
            max="1000"
            v-model="ketoasidoz.seker"
          />
        </div>
        <div class="labeledit">
          <label for="p-ph">pH : </label>
          <input type="text" name="" id="p-ph" v-model="ketoasidoz.ph" />
        </div>
        <div class="labeledit">
          <label for="p-pco2">pCO2 : </label>
          <input type="text" name="" id="p-pco2" v-model="ketoasidoz.pco2" />
        </div>
        <div class="labeledit">
          <label for="p-hco3">HCO3 : </label>
          <input type="text" name="" id="p-hco3" v-model="ketoasidoz.hco3" />
        </div>

        <h3>Tedavi Bilgileri</h3>
        <div class="labeledit">
          <label for="p-sivi">Sıvı Tedavisi : </label>
          <select v-model="ketoasidoz.sivi" id="p-sivi">
            <option value="1">Hafif Dehidratasyon - 2500 cc/m2</option>
            <option value="2">Hafif - Orta Dehidratasyon - 3000 cc/m2</option>
            <option value="3">Orta - Ağır Dehidratasyon - 3500 cc/m2</option>
            <option value="4">Ağır Dehidratasyon - 4000 cc/m2</option>
          </select>
        </div>
        <div class="labeledit">
          <label for="p-potasyum">Potasyum : </label>
          <select id="p-potasyum" v-model="ketoasidoz.potasyum">
            <option value="40">40 meq/L</option>
            <option value="50">50 meq/L</option>
            <option value="60">60 meq/L</option>
            <option value="70">70 meq/L</option>
            <option value="80">80 meq/L</option>
          </select>
        </div>
        <div class="labeledit">
          <label for="p-insulin">İnsulin Dozu : </label>
          <select id="p-insulin" v-model.number="ketoasidoz.insulin">
            <option value="0.01">0.01 ü/kg/h</option>
            <option value="0.02">0.02 ü/kg/h</option>
            <option value="0.03">0.03 ü/kg/h</option>
            <option value="0.04">0.04 ü/kg/h</option>
            <option value="0.05">0.05 ü/kg/h</option>
            <option value="0.06">0.06 ü/kg/h</option>
            <option value="0.07">0.07 ü/kg/h</option>
            <option value="0.08">0.08 ü/kg/h</option>
            <option value="0.09">0.09 ü/kg/h</option>
            <option value="0.1">0.1 ü/kg/h</option>
            <option value="0.15">0.15 ü/kg/h</option>
            <option value="0.2">0.2 ü/kg/h</option>
          </select>
        </div>
        <br />
        <button class="btn btn-indigo fr" @click="print()">
          <i class="fa fa fa-print"></i>
          Ketoasidoz Çizelgesini Yazdır
        </button>
      </div>
      <div id="printArea" class="p-not order">
        <template v-if="ketoasidoz.kilo > 0">
          <p>
            <center>
              <b>DİYABETİK KETOASİDOZ TAKİP ÇİZELGESİ</b>
            </center>
          </p>
          <p style="text-align: right">
            <b>{{ ketoasidoz.dkastart | moment("DD.MM.YYYY HH:mm") }}</b>
          </p>
          <p>
            <b
              >{{ ketoasidoz.adi | toUpperCase }} ( {{ ketoasidoz.kilo }} KG)</b
            >
          </p>
          <ul>
            <li>
              Başvuru sırasında
              <b>HEMOGRAM, BİYOKİMYA, KAN GAZI, TİT</b> alındı
            </li>
            <li>
              Başvuru sırasında Kan Şekeri
              <b>{{ ketoasidoz.seker }}</b> mg/dL ölçüldü.
            </li>
            <li>
              Başvuru sırasında Kan Gazı :
              <ul>
                <li>
                  pH : <b>{{ ketoasidoz.ph }}</b>
                </li>
                <li>
                  pCO2 : <b>{{ ketoasidoz.pco2 }}</b>
                </li>
                <li>
                  HCO3 : <b>{{ ketoasidoz.hco3 }}</b>
                </li>
              </ul>
            </li>
            <li>
              Vücut m2 : <b>{{ mayi[0] }}</b> olarak hesaplandı.
              <b>{{ hizm2 }}</b> olacak şekilde mayi başlandı. Mayi hızı
              <b>{{ mayi[ketoasidoz.sivi] }} cc/h</b> olacak şekilde ayarlandı.
            </li>

            <li>
              Geliş Kan Şekerine göre mayi türü :
              <b>{{ mayituru }}</b> olacak şekilde düzenlendi
            </li>
            <li>
              Hastanın mayisine katılacak olan potasyum
              <b>Her 1000 cc'ye {{ ketoasidoz.potasyum }} meq</b>
              olacak şekilde düzenlendi
            </li>
            <li>
              İnsulin infüzyon hızı
              <b>{{ ketoasidoz.insulin }} ü/kg/h</b>
              olacak şekilde ayarlandı. 50 ünite İnsulin + 50 cc SF içine
              katılarak
              <b>{{ insulinhiz }} cc/h</b> hızında başlandı
            </li>
          </ul>
          Kan Şekeri takibine göre Mayi Türleri :
          <ul>
            <li>KŞ > 500 mg/dl ise <b>% 0.9 NaCl (Düz SF)</b></li>
            <li>
              KŞ : 500 - 250 ise
              <b>2/3 lük SF (2 birim SF + 1 birim %5 deks)</b>
            </li>
            <li>
              KŞ : 250 - 100 ise
              <b>1/3 lük SF - %5 deks (1 birim SF + 2 birim %5 deks)</b>
            </li>
            <li>
              KŞ &lt; 100 mg/dl ise
              <b>1/3 lük SF - %10 deks (1 birim SF + 2 birim %10 deks)</b>
            </li>
          </ul>

          <table>
            <thead>
              <tr>
                <th class="c-center">#</th>
                <th class="c-center">Saat</th>
                <th class="c-center">KŞ</th>
                <th class="c-center">İnsülin</th>
                <th class="c-center">Potasyum</th>
                <th>Mayi</th>
                <th>Plan</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="c-center w-8">0. <br />Saat</td>
                <td class="c-center w-8">
                  {{ ketoasidoz.dkastart | moment("HH:mm") }}
                </td>
                <td class="c-center w-8">
                  {{ ketoasidoz.seker }}
                </td>
                <td class="c-center w-12">
                  {{ ketoasidoz.insulin + " ü/kg/h (" + insulinhiz + " cc/h)" }}
                </td>
                <td class="c-center w-12">
                  {{ ketoasidoz.potasyum + " meq/L" }}
                </td>
                <td class="w-12">{{ mayituru }}</td>
                <td class="w-12"></td>
              </tr>
              <tr v-for="s in saatlist" :key="s.sira">
                <td class="c-center w-8">{{ s.sira }}. <br />Saat</td>
                <td class="c-center w-8">
                  {{ s.saat | moment("HH:mm") }}
                </td>
                <td class="c-center w-8"></td>
                <td class="c-center w-12"></td>
                <td class="c-center w-12"></td>
                <td class="w-12"></td>
                <td class="w-12">{{ s.plan }}</td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ketoasidoz",
  data() {
    return {
      ketoasidoz: {
        adi: "",
        kilo: 0,
        sivi: "1",
        seker: 0,
        ph: "",
        pco2: "",
        hco3: "",
        insulin: 0.05,
        potasyum: 40,
        dkastart: null,
      },
    };
  },
  computed: {
    patientList() {
      return this.$store.getters.getPatients;
    },
    user() {
      return this.$store.getters.getUser;
    },

    saatlist() {
      let result = Array();
      let self = this;
      for (let index = 1; index < 25; index++) {
        let planlar = Array();
        if (index % 2 == 0) {
          planlar.push("Kan Gazı");
        }
        if (index % 4 == 0) {
          planlar.push("İnsülin Seti Değiştirme");
          planlar.push("Biyokimya ve TİT");
        }
        result.push({
          sira: index,
          saat: self.$moment(self.ketoasidoz.dkastart).add(index, "h"),
          plan: planlar.join(),
        });
      }
      return result;
    },

    mayi() {
      var kg = Number(this.ketoasidoz.kilo);
      var m2 = (4 * kg + 7) / (90 + kg);
      return [
        Math.round(m2 * 100) / 100,
        Math.round((2500 * m2) / 24),
        Math.round((3000 * m2) / 24),
        Math.round((3500 * m2) / 24),
        Math.round((4000 * m2) / 24),
      ];
    },
    hizm2() {
      let result;
      switch (this.ketoasidoz.sivi) {
        case "1":
          result = "2500 cc/m2";
          break;
        case "2":
          result = "3000 cc/m2";
          break;
        case "3":
          result = "3500 cc/m2";
          break;
        case "4":
          result = "4000 cc/m2";
          break;
        default:
          result = "(-)";
          break;
      }
      return result;
    },
    mayituru() {
      let result;
      switch (true) {
        case this.ketoasidoz.seker > 500:
          result = "% 0.9 NaCl";
          break;
        case this.ketoasidoz.seker <= 500 && this.ketoasidoz.seker > 250:
          result = "2/3 lük SF";
          break;
        case this.ketoasidoz.seker <= 250 && this.ketoasidoz.seker >= 100:
          result = "1/3 lük SF - %5 deks";
          break;
        case this.ketoasidoz.seker < 100:
          result = "1/3 lük SF - %10 deks";
          break;
      }
      return result;
    },
    insulinhiz() {
      let result;
      result =
        Math.round(this.ketoasidoz.insulin * this.ketoasidoz.kilo * 100) / 100;
      return result;
    },
  },
  methods: {
    // Tabs
    print() {
      const options = {
        name: "_blank",
        specs: ["height=800", "height=800", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://pediatrim.net/print/birthlist.css"],
      };
      this.$htmlToPaper("printArea", options);
    },
    // İlaçlar
  },
  created() {
    var n = this.$moment(new Date());
    this.ketoasidoz.dkastart = n.format("YYYY-MM-DDTHH:mm");
  },
};
</script>

<style lang="scss">
.protokol {
  flex: 1 1 40%;
}
.order {
  flex: 1 1 60%;
  margin: 78px 10px 10px 10px;
  table {
    border-spacing: 0;
    width: 100%;
    border-collapse: collapse;
    border-radius: 5px;
    table-layout: auto;
    tr td {
      border: 1px solid $gray-400;
      word-wrap: break-word;
      white-space: pre-line;
    }
    th,
    td {
      text-align: left;
      padding: 5px;
      color: #000;
    }
    th {
      background-color: $gray-300;
      border: 1px solid $gray-400;
    }
    tr:nth-child(even) {
      background: $gray-100;
    }
    tr:nth-child(odd) {
      background: white;
    }
  }
  .c-center {
    text-align: center;
  }
  .c-top {
    vertical-align: top;
  }
  .w-4 {
    width: 4%;
  }
  .w-8 {
    width: 8%;
  }
  .w-12 {
    width: 12%;
  }
}
.protokol {
  margin: 78px 10px 10px 10px;
  display: flex;
  flex-direction: column;
  h3 {
    padding: 10px;
  }
}
</style>
